import { fg } from '@atlaskit/platform-feature-flags';

import type { Edition, Product } from '../types';

/**
 * Gives the next highest trial offering name, if available.
 */
export const getTrialOfferingName = (product: Product, edition: Edition): Edition => {
	if (edition === 'standard') {
		if (product === 'jira' && fg('edition_awareness_upsell_jira_fg')) {
			return 'premium';
		}
		if (product === 'jira-service-management' && fg('edition_awareness_upsell_jsm_fg')) {
			return 'premium';
		}
		if (product === 'confluence' && fg('edition_awareness_standard_upsell_confluence_ab_fg')) {
			return 'premium';
		}
		if (product === 'jira-product-discovery' && fg('upsell_edition_awareness_jpd_fg')) {
			return 'premium';
		}
	}

	return 'standard';
};
